import { createLazyComponent, LazyImport, LazyModule } from 'owa-bundling';
import { FilePickerAction, FilePickerViewType, FileSelectionFilter, SelectedFilesSource, } from 'owa-filepicker-store';
var lazyModule = new LazyModule(function () {
    return System.import(/* webpackChunkName: "FilePicker" */ './lazyIndex');
});
// Delay loaded components
export var LocalComputerFilePicker = createLazyComponent(lazyModule, function (m) { return m.LocalComputerFilePicker; });
// Delay loaded imports
export var lazyFilePicker = new LazyImport(lazyModule, function (m) { return m.filePicker; });
export var lazyActionsPanel = new LazyImport(lazyModule, function (m) { return m.actionsPanel; });
export { AttachmentDataProviderType, FilePickerAction, FilePickerViewType, FileSelectionFilter, SelectedFilesSource, };
//# sourceMappingURL=index.js.map